(function () {
  'use strict';

  var POLL_INTERVAL = 500;
  var POLL_MAX = 20;
  var pollCount = 0;
  var syncObserver = null;
  var isSyncing = false;

  /* ─── bar helpers ──────────────────────────────────────── */

  function getBars() {
    return Array.from(document.querySelectorAll('.kaching-bundles__bar'));
  }

  function barTitle(bar) {
    var el = bar.querySelector('[class*="bar-title"],[class*="bar-label"],[class*="bar-name"]');
    return (el ? el.textContent : bar.textContent).trim();
  }

  function getBundleQuantity(bar) {
    if (bar.dataset.quantity) return parseInt(bar.dataset.quantity, 10);
    if (bar.dataset.qty)      return parseInt(bar.dataset.qty, 10);
    var text = bar.textContent.trim();
    var add  = text.match(/(\d+)\s*\+\s*(\d+)/);
    if (add)  return parseInt(add[1], 10) + parseInt(add[2], 10);
    var mult = text.match(/[xX×]\s*(\d+)/);
    if (mult) return parseInt(mult[1], 10);
    return null;
  }

  function getOptionText(bar, i) {
    var pricing = bar.querySelector('[class*="bar-pricing"],[class*="pricing"]');
    var label   = barTitle(bar);
    var price   = pricing ? pricing.textContent.trim().split(/\s{2,}/)[0].trim() : '';
    return price ? label + ' — ' + price : label;
  }

  /* ─── stel globale override in (gelezen door vroege interceptor) ───── */

  function setTarget(idx) {
    var bars = getBars();
    var bar  = bars[idx];
    if (!bar) { window._stickyBundleTarget = null; return; }
    window._stickyBundleTarget = {
      qty:       getBundleQuantity(bar),
      title:     barTitle(bar),
      allTitles: bars.map(barTitle)
    };
  }

  /* ─── prijs bijwerken in sticky ATC ────────────────────── */

  var _priceApplying = false;
  function updateStickyPrice() {
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (!sel) return;
    function t(el){ return el ? el.textContent.trim() : ''; }
    var price = t(sel.querySelector('[class*="bar-price"]'));
    var full  = t(sel.querySelector('[class*="bar-full-price"]'));
    var save  = t(sel.querySelector('[class*="bar-label"]'));
    if (!price) return;
    _priceApplying = true;
    document.querySelectorAll('[id^="sticky-atc-separate-price-"],[id^="sticky-atc-price-"]').forEach(function (box) {
      box.querySelectorAll('.price-item--sale').forEach(function (el) { el.textContent = price; });
      var comp = box.querySelector('.price__sale .price-item--regular');
      if (comp && full) comp.textContent = full;
      box.querySelectorAll('.price__regular .price-item--regular').forEach(function (el) { el.textContent = price; });
      if (save) box.querySelectorAll('.nowrap').forEach(function (el) { if (/bespaar/i.test(el.textContent)) el.textContent = save; });
    });
    setTimeout(function () { _priceApplying = false; }, 60);
  }
  function _observeStickyPrice() {
    var box = document.querySelector('[id^="sticky-atc-separate-price-"]');
    if (!box || box._bundleObs) return;
    box._bundleObs = new MutationObserver(function () { if (!_priceApplying) setTimeout(updateStickyPrice, 30); });
    box._bundleObs.observe(box, { childList: true, subtree: true, characterData: true });
  }

  /* ─── dropdown syncen ──────────────────────────────────── */

  function syncSelect() {
    var select = document.querySelector('.kaching-sticky-select');
    if (!select) return;
    var bars = getBars();
    var idx  = bars.findIndex(function (b) { return b.classList.contains('kaching-bundles__bar--selected'); });
    if (idx >= 0) {
      if (select.selectedIndex !== idx) select.selectedIndex = idx;
      setTarget(idx);
    }
    updateStickyPrice();
  }

  /* ─── dropdown bouwen ──────────────────────────────────── */

  function buildDropdown() {
    var stickyAtc = document.querySelector('[id^="sticky-atc-"]');
    if (!stickyAtc) return false;
    if (stickyAtc.querySelector('.kaching-sticky-select')) return true;

    var bars = getBars();
    if (!bars.length) return false;

    var outer = document.createElement('div');
    outer.className = 'product-form__input kaching-sticky-wrap';
    outer.style.cssText = 'flex-shrink:0; display:flex; align-items:center; margin-left:1.2rem;';

    var inner = document.createElement('div');
    inner.className = 'select no-background';
    inner.style.cssText = 'position:relative;';

    var select = document.createElement('select');
    select.className = 'kaching-sticky-select select__select';

    bars.forEach(function (bar, i) {
      var el = document.createElement('option');
      el.value = i;
      el.textContent = getOptionText(bar, i);
      if (bar.classList.contains('kaching-bundles__bar--selected')) el.selected = true;
      select.appendChild(el);
    });

    /* bij wijziging: Kaching-bar activeren EN target instellen */
    select.addEventListener('change', function () {
      var allBars = getBars();
      var chosen  = allBars[parseInt(select.value, 10)];
      if (!chosen) return;
      isSyncing = true;
      setTarget(parseInt(select.value, 10));  // stel EERST target in
      (chosen.querySelector('label') || chosen).click();
      setTimeout(function () { updateStickyPrice(); isSyncing = false; }, 400);
    });

    /* caret SVG */
    var svg  = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', 'icon icon-caret');
    svg.setAttribute('viewBox', '0 0 14 14');
    path.setAttribute('d', 'M2 5l5 5 5-5');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('fill', 'none');
    svg.appendChild(path);
    inner.appendChild(select);
    inner.appendChild(svg);
    outer.appendChild(inner);

    var existingPicker = stickyAtc.querySelector('[id^="StickyAtcVariantPicker-"]');
    var content        = stickyAtc.querySelector('.sticky-atc__left__content');
    if (existingPicker && existingPicker.parentNode) {
      existingPicker.parentNode.insertBefore(outer, existingPicker.nextSibling);
    } else if (content) {
      content.appendChild(outer);
    } else {
      var left = stickyAtc.querySelector('.sticky-atc__left');
      left ? left.insertBefore(outer, left.querySelector('.sticky-atc__button') || null)
           : stickyAtc.appendChild(outer);
    }

    return true;
  }

  /* ─── init ─────────────────────────────────────────────── */

  function tryInit() {
    if (buildDropdown()) {
      syncSelect();
      _observeStickyPrice();

      document.addEventListener('click', function (e) {
        if (e.target.closest('.kaching-bundles__bar') && !isSyncing) {
          setTimeout(syncSelect, 300);
        }
      });

      if (syncObserver) syncObserver.disconnect();
      var container = document.querySelector('.kaching-bundles, [class*="kaching-bundles"]');
      if (container) {
        syncObserver = new MutationObserver(function () {
          if (!isSyncing) setTimeout(syncSelect, 150);
        });
        syncObserver.observe(container, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }
      return;
    }
    pollCount++;
    if (pollCount < POLL_MAX) setTimeout(tryInit, POLL_INTERVAL);
  }

  document.addEventListener('DOMContentLoaded', function () { setTimeout(tryInit, 400); });
  window.addEventListener('load', function () { setTimeout(tryInit, 600); });

})();
